// Temporary cache for show_in_equipment until backend supports it
// This will be removed once backend is updated

const CACHE_KEY = 'category_equipment_settings_temp';

export const getCachedSettings = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    return cached ? JSON.parse(cached) : {};
  } catch {
    return {};
  }
};

export const setCachedSetting = (categoryId, showInEquipment) => {
  try {
    const settings = getCachedSettings();
    settings[categoryId] = showInEquipment;
    localStorage.setItem(CACHE_KEY, JSON.stringify(settings));
    console.log(`Cached: Category ${categoryId} show_in_equipment=${showInEquipment}`);
  } catch (error) {
    console.error('Error caching setting:', error);
  }
};

export const getCachedSetting = (categoryId) => {
  const settings = getCachedSettings();
  return settings[categoryId] || false;
};

export const removeCachedSetting = (categoryId) => {
  try {
    const settings = getCachedSettings();
    delete settings[categoryId];
    localStorage.setItem(CACHE_KEY, JSON.stringify(settings));
  } catch (error) {
    console.error('Error removing cached setting:', error);
  }
};